const objectToURLSearchParams = (payload: Object): FormData => {
  const params = new URLSearchParams();

  Object.keys(payload).forEach((key: string) => {
    params.set(key, payload[key]);
  });

  return params;
};

export default objectToURLSearchParams;
